export const MissionsDeliveredIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22" fill="none">
    <path d="M7.87891 1V4.17" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.539062 1.92999L2.78906 4.16999" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.4587 1.92999L13.2188 4.16999" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.87891 20.84V17.67" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.539062 19.91L2.78906 17.67" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.4587 19.91L13.2188 17.67" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.99906 15.38C12.1191 15.38 15.4591 13.4414 15.4591 11.05C15.4591 8.65857 12.1191 6.71997 7.99906 6.71997C3.87902 6.71997 0.539062 8.65857 0.539062 11.05C0.539062 13.4414 3.87902 15.38 7.99906 15.38Z"
      stroke="#231F20"
      strokeMiterlimit="10"
    />
    <path
      d="M7.87992 12.12C8.54819 12.12 9.08992 11.5783 9.08992 10.91C9.08992 10.2417 8.54819 9.70001 7.87992 9.70001C7.21166 9.70001 6.66992 10.2417 6.66992 10.91C6.66992 11.5783 7.21166 12.12 7.87992 12.12Z"
      stroke="#231F20"
      strokeMiterlimit="10"
    />
  </svg>
);
